export const AgentsActions = {
    SET_DATA: "[Agents] set data"    
};

export const setDataAction = (data) => {
    return {
        type: AgentsActions.SET_DATA,
        payload: data,
    };
};